import { useParams } from 'react-router'

import { useFetchAccountStatements } from '@features/accounts/hooks/useFetchAccountStatements'

import { ChartOfAccountsUrlParams } from '../types/chartOfAccountsUrlParams'
import { useAccountFilters } from './useAccountFilters'

export const useAccountStatement = () => {
  const { accountId } = useParams<ChartOfAccountsUrlParams>()
  const [{ sortDirection, searchQuery, withVoided, period }] = useAccountFilters()

  const { accountStatement, ...rest } = useFetchAccountStatements({
    accountId: accountId as string,
    period,
    searchQuery,
    sortDirection,
    withVoided,
  })

  return { accountStatement, ...rest }
}
